<template>
  <v-container fluid grid-list-md>
    <v-layout wrap>
      <v-flex xs12>
        <h1>ЖКУ. Квитанции</h1>
      </v-flex>
      <router-view></router-view>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  created: function () {
    // this.$store.dispatch('esrn_common/fetchTowns', {'federationSubject_id': 414})
    // this.$store.dispatch('esrn_common/fetchStreets', {'town_id': 726914})
    this.$store.dispatch('esrn_common/fetchFederationBorough', { 'federationSubject_id': '' })
    this.$store.dispatch('esrn_common/fetchSuperTowns', { 'federationSubject_id': '' })
    this.$store.dispatch('gku_receipts/fetchServices')
    this.$store.dispatch('esrn_common/fetchTowns', { 'federationSubject_id': '' })
    // this.$store.dispatch('esrn_common/fetchBorough', {'town_id': 726914})
    // this.$store.dispatch('esrn_common/fetchStreets', {'town_id': 726914})
  }
}

</script>

<style>

</style>
